$(function() {

  // アイシップアール動的ページ用のテキストを変更
  //会員登録
  if ($('#sysMemberRegisterIndex').length >= 1) {
    $('.sysHeadline').text('REGISTRATION');
    let $text = $('.sysAddress1').find('.sysFormLabel');
    let text = $text.html();
    let html = text.replace(/郡市区/g, '市区町村');
    $text.html(html);
    $('.sysFormItem.sysName .sysFormLabel,.sysFormItem.sysNameKana .sysFormLabel').append('<span>名字と名前の間に全角スペースをいれてください。</span>');
  }
  // 会員登録確認
  if ($('#sysMemberRegisterConfirm').length >= 1) {
    $('.sysHeadline').text('REGISTRATION');
    let $text = $('.sysAddress1').find('.sysFormLabel');
    let text = $text.html();
    let html = text.replace(/郡市区/g, '市区町村');
    $text.html(html);
  }
  // 配送先選択
  if ($('#sysDestination').length >= 1) {
    $('.sysHeadline').text('ショッピングカート');
    $('#sysDestinationOther').text('新しいお届け先を入力する');
  }
  // お支払い方法の選択
  if ($('#sysPayment').length >= 1) {
    let $text = $('.sysPaymentDescription');
    let text = $text.html();
    let html = text.replace(/324/g, '330');
    $text.html(html);
  }
  // お問い合わせ
  if ($('#sysFormIndex').length >= 1 && $('.form-inquiry').length >= 1) {
    $('.sysHeadline').text('お問い合わせ');
  }
  // お問い合わせ確認
  if ($('#sysFormConfirm').length >= 1) {
    $('.sysHeadline').text('お問い合わせ');
  }
  // お問い合わせ完了
  if ($('#sysFormThanks').length >= 1) {
    $('.sysHeadline').text('お問い合わせ');
  }
  // ログインページ
  if ($('#sysMypageLogin').length >= 1) {
    $('.sysHeadline').text('LOG IN');
  }
  // ログインアウト
  if ($('#sysMypageLogout').length >= 1) {
    $('.sysHeadline').text('LOG OUT');
    $('#sysMain').append('<a href="http://kokuryudo-cosme.aispr.jp/" class="c-button-basic -bg-black p-button-logout">トップへ戻る</a>');
  }
  // マイページ
  if ($('#sysMypageIndex').length >= 1) {
    $('.sysHeadline').text('MY PAGE');
  }
  // 会員情報編集 確認
  if ($('#sysMypageEditConfirm').length >= 1) {
    $('.sysHeadline').text('REGISTRATION');
    let $text = $('.sysAddress1').find('.sysFormLabel');
    let text = $text.html();
    let html = text.replace(/郡市区/g, '市区町村');
    $text.html(html);
  }
  // 退会確認
  if ($('#sysMypageWithdrawalConfirm').length >= 1) {
    const $text = $('.sysWithdrawal').find('p').eq(1);
    const text = $text.text();
    if (text === '退会されますと、会員登録後の「継続中」定期購入申込みも全てキャンセルされます。') {
      $text.text('退会されますと、購入履歴などすべての情報が削除されます。');
    }
  }
  // 退会完了
  if ($('#sysMypageWithdrawalDone').length >= 1) {
    const $content = $('.sysWithdrawal');
  }
  // 返品・交換・返金フォーム
  if ($('.form-form-cancel').length >= 1) {
    $('#sysMain h2').css('display', 'block').css('margin-top', '0').addClass('sysHeadline _fz-30');
    $('.sys6 input[type="text"]').css('width', '200px');
    $('.sys6 button[type="submit"]').text('住所検索');
    $('.sys11').before('<p style="color:#E7528C;">※返金をご希望の方は、以下の項目もご入力ください。</p>');
  }
  // 登録フォームの市区群を市区町村に
  if ($('.sysFormLabel').length >= 1) {
    // $('.sysFormLabel').each(function () {
    //   if ($(this).text().match('郡市区')) {
    //     $(this).text('市区町村');
    //   }
    // });
    $('.errorMessage li').each(function () {
      if ($(this).text().match('郡市区が入力されていません')) {
        $(this).text('市区町村が入力されていません');
      }
    });
    $('.sysErrorMessage').each(function () {
      if ($(this).text().match('郡市区が入力されていません')) {
        $(this).text('市区町村が入力されていません');
      }
    });
  }
});
